import type { DeliveryResolver } from '@grandvisionhq/shipping'
import { defaultDeliveryResolver } from '@grandvisionhq/shipping'
import { isPresent } from '@grandvisionhq/utils'

type DeliveryResolverFactory = (products?: any[], productType?: string) => DeliveryResolver

export const deliveryResolverFactory: DeliveryResolverFactory = (products, _) => {
  return (config, availability) => {
    if (Array.isArray(products)) {
      // Custom logic which VE uses at this moment:
      // - always show longest delivery time
      // - when cart contains RX (sun or frames) delivery is 10-15
      // - when cart contains non-prescription-bundle (Blue light filter for instance) delivery is 10-15
      // - when cart contains CL delivery is 5-7
      // - For solutions,accessories,sunglasses delivery is 5-7
      const types = new Set(
        products
          .filter((product) => product)
          .map((p) => p.type)
          .filter(isPresent)
      )

      const sunglasses = products.filter(
        (p) => p?.productType?.obj?.name === 'Sunglasses' || p?.productType === 'Sunglasses'
      )
      const isSunglassesWithPrescription = sunglasses.some(
        (p) =>
          p.isOfferedWithPrescriptions ||
          p.masterVariant?.isOfferedWithPrescriptions ||
          p.variants.some((v) => v.isOfferedWithPrescriptions)
      )

      if (
        types.has('prescription-glasses') ||
        isSunglassesWithPrescription ||
        types.has('non-prescription-bundle')
      ) {
        return ['10-15']
      } else {
        return ['5-7']
      }
    }

    return defaultDeliveryResolver(config, availability)
  }
}

export const deliveryResolverFactoryForOrder: DeliveryResolverFactory = (products, _) => {
  return (config, availability) => {
    if (Array.isArray(products)) {
      // Custom logic which VE uses at this moment:
      // - always show longest delivery time
      // - when cart contains RX (sun or frames) delivery is 7-10
      // - when cart contains non-prescription-bundle (Blue light filter for instance) delivery is 5
      // - when cart contains CL delivery is 3-5
      // - For solutions,accessories,sunglasses delivery is next day
      const types = new Set(products.map((p) => p.productType).filter(isPresent))

      const sunglasses = products.filter(
        (p) => p?.productType === 'Sunglasses' || p?.productType === 'sunglasses'
      )
      const isSunglassesWithPrescription = sunglasses.some((p) => isPresent(p.prescription))

      if (
        types.has('prescription-glasses') ||
        isSunglassesWithPrescription ||
        types.has('non-prescription-bundle')
      ) {
        return ['10-15']
      } else {
        return ['5-7']
      }
    }

    return defaultDeliveryResolver(config, availability)
  }
}
